import { SxProps, Theme } from '@mui/material';
import {
  GridRowHeightParams,
  GridRowHeightReturnValue
} from '@mui/x-data-grid-pro';

export interface SharedProps {
  sx?: SxProps<Theme> | undefined;
  getRowHeight?: (params: GridRowHeightParams) => GridRowHeightReturnValue;
}

export const withDutyCodeSharedProps = (Component) => {
  const sharedProps = {
    sx: {
      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
        py: '8px'
      }
    },
    getRowHeight: () => 'auto'
  };

  function WithDutyCodeSharedPropsWrapper(props) {
    return <Component {...props} {...sharedProps} />;
  }
  return WithDutyCodeSharedPropsWrapper;
};
